import getConfig from 'next/config';
import React from 'react';
import { Modal, Paper, Typography, Box, IconButton, Button } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import { useTheme } from '@mui/material/styles';
import styles from './style';

const { publicRuntimeConfig } = getConfig();

const ESIMTooltip = ({ open, onClose, cmsData }) => {
  const theme = useTheme();
  const features = cmsData?.Summary_ESIMTooltip?.ESIMFeature || [];
  return (
    <Modal open={open} onClose={onClose} sx={styles(theme).modalWrapper}>
      <Paper sx={styles(theme).modalPaper}>
        <IconButton onClick={onClose} sx={styles(theme).closeButton}>
          <CloseIcon />
        </IconButton>
        <Box sx={styles(theme).modalContent}>
          <Typography variant='h3' sx={styles(theme).title}>
            {cmsData?.Summary_ESIMTooltip?.title}
          </Typography>
          <Typography variant='body1' align='center' sx={styles(theme).headingText}>
            {cmsData?.Summary_ESIMTooltip?.description}
          </Typography>
          {features.map(feature => (
            <Box sx={styles(theme).infoRow}>
              <Box
                component='img'
                src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${feature?.featureIcon.data.attributes.url}`}
                alt=''
                sx={styles(theme).icon}
              />
              <Typography variant='body1' sx={styles(theme).descriptionText}>
                <Typography variant='h6' component='span' sx={styles(theme).inlineHeading}>
                  {feature?.featureTitle}
                </Typography>{' '}
                {feature?.featureDescription}
              </Typography>
            </Box>
          ))}
          <Button variant='buttonMedium' onClick={onClose} sx={styles(theme).mobileButton}>
            Close
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export default ESIMTooltip;
